<div class="wrapper">
	<div class="text-container" role="region" aria-label="Text container">
		<ion-row role="region" aria-label="Content section">
			<ion-col>
				<h3 class="info">{{ 'available_driver_modal.info' | translate }}</h3>
			</ion-col>
		</ion-row>
		<ion-row role="region" aria-label="Content section">
			<p class="text">{{ 'available_driver_modal.text' | translate }}</p>
		</ion-row>
	</div>
	<ion-row role="region" aria-label="Content section">
		<ion-col class="button-block">
			<ion-button class="button" (click)="dismiss()">
				{{ 'order.note.ok' | translate }}
			</ion-button>
		</ion-col>
	</ion-row>
</div>
